(() => {
  const burvontiTemplateSelector = [
    '.template-suffix-burvonti-native',
    '.template-suffix-burvonti-engagement-pdp',
    '.template-suffix-burvonti-native-hero',
    '.template-suffix-burvonti-jewelry-pdp'
  ].join(', ');

  reorderBurvontiNativeMediaGalleries();

  document.querySelectorAll('[data-burvonti-ring-size]').forEach((ringSize) => {
    if (ringSize.closest(burvontiTemplateSelector)) initializeRingSize(ringSize);
  });
  document.querySelectorAll('form.js-product-form').forEach((form) => {
    if (form.closest(burvontiTemplateSelector)) initializeRingSizeValidation(form);
  });
  document.querySelectorAll('[data-burvonti-engraving]').forEach((engraving) => {
    if (engraving.closest(burvontiTemplateSelector)) initializeEngraving(engraving);
  });
  document.querySelectorAll('[data-burvonti-service-tools]').forEach((serviceTools) => {
    if (serviceTools.closest(burvontiTemplateSelector)) initializeServiceTools(serviceTools);
  });
  document.querySelectorAll('.section-main-product').forEach((section) => {
    if (section.closest(burvontiTemplateSelector)) initializeAdaptivePurchaseCta(section);
  });

  document.addEventListener('on:variant:change', (event) => {
    const section = event.target.closest('.section-main-product');
    if (!section || !section.closest(burvontiTemplateSelector)) return;

    const selectedOptions = event.detail?.selectedOptions;
    if (!Array.isArray(selectedOptions)) return;

    section.querySelectorAll('[data-burvonti-ring-detail-carat]').forEach((caratNode) => {
      const optionIndex = Number(caratNode.getAttribute('data-option-index'));
      if (!Number.isInteger(optionIndex) || selectedOptions[optionIndex] == null) return;
      caratNode.textContent = selectedOptions[optionIndex];
    });

    window.setTimeout(() => {
      section.querySelectorAll('[data-burvonti-ring-size]').forEach((ringSize) => {
        initializeRingSize(ringSize);
        restoreRingSizeSelection(section, ringSize);
      });
      section.querySelectorAll('form.js-product-form').forEach(initializeRingSizeValidation);
    }, 0);
  });

  document.querySelectorAll('[data-burvonti-order-details]').forEach((orderDetails) => {
    if (!orderDetails.closest(burvontiTemplateSelector)) return;
    const dateNode = orderDetails.querySelector('[data-burvonti-delivery-date]');
    const leadDays = Number(orderDetails.getAttribute('data-lead-business-days') || 14);
    if (!dateNode) return;
    const date = addBusinessDays(new Date(), leadDays);
    dateNode.textContent = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  });

  function initializeRingSize(ringSize) {
    if (ringSize.hasAttribute('data-burvonti-ring-size-initialized')) return;

    const input = ringSize.querySelector('input[name="properties[Ring Size]"]');
    const mainForm = ringSize.closest('form.js-product-form');
    const section = ringSize.closest('.section-main-product');
    if (!input || !mainForm || !section) return;

    ringSize.setAttribute('data-burvonti-ring-size-initialized', '');
    restoreRingSizeSelection(section, ringSize);
    syncStickyRingSizeState(section, input.value);

    ringSize.querySelectorAll('[data-ring-size-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.getAttribute('data-ring-size-value');
        if (!value) return;

        input.value = value;
        section.setAttribute('data-burvonti-selected-ring-size', value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        ringSize.querySelectorAll('[data-ring-size-value]').forEach((item) => {
          item.setAttribute('aria-pressed', item.getAttribute('data-ring-size-value') === value ? 'true' : 'false');
        });
        syncStickyRingSizeState(section, value);
        hideRingSizeErrors(section, mainForm);
      });
    });

    const moreButton = ringSize.querySelector('[data-burvonti-ring-size-more]');
    const grid = ringSize.querySelector('[data-burvonti-ring-size-grid]');
    if (moreButton && grid) {
      const originalPosition = document.createComment('burvonti-ring-size-more-position');
      moreButton.before(originalPosition);

      moreButton.addEventListener('click', () => {
        const shouldOpen = grid.hasAttribute('hidden');
        grid.toggleAttribute('hidden', !shouldOpen);
        moreButton.setAttribute('aria-expanded', String(shouldOpen));
        moreButton.textContent = shouldOpen ? 'Show Fewer Sizes' : 'View More Sizes';

        if (shouldOpen) {
          grid.after(moreButton);
        } else if (!shouldOpen) {
          originalPosition.after(moreButton);
        }
      });
    }
  }

  function initializeRingSizeValidation(form) {
    if (form.hasAttribute('data-burvonti-ring-size-validation-initialized')) return;
    form.setAttribute('data-burvonti-ring-size-validation-initialized', '');

    form.addEventListener('submit', (event) => {
      const section = form.closest('.section-main-product');
      const ringSize = section?.querySelector('[data-burvonti-ring-size]');
      const requiredRingSize = ringSize?.querySelector('input[name="properties[Ring Size]"]');
      if (!section || !ringSize || !requiredRingSize || requiredRingSize.value) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const mainForm = ringSize.closest('form.js-product-form');
      const message = 'Please choose a ring size before adding this ring to your bag.';
      showRingSizeErrors(section, mainForm, message);
      revealRingSize(ringSize);
    }, true);
  }

  function restoreRingSizeSelection(section, ringSize) {
    const selectedSize = section.getAttribute('data-burvonti-selected-ring-size');
    const input = ringSize.querySelector('input[name="properties[Ring Size]"]');
    if (!selectedSize || !input) return;

    input.value = selectedSize;
    ringSize.querySelectorAll('[data-ring-size-value]').forEach((item) => {
      item.setAttribute('aria-pressed', item.getAttribute('data-ring-size-value') === selectedSize ? 'true' : 'false');
    });
    syncStickyRingSizeState(section, selectedSize);
  }

  function syncStickyRingSizeState(section, selectedSize) {
    const stickyButton = section.querySelector('.sticky-atc .add-to-cart');
    if (!stickyButton || stickyButton.disabled) return;

    if (!stickyButton.dataset.burvontiReadyText) {
      stickyButton.dataset.burvontiReadyText = stickyButton.dataset.addToCartText || stickyButton.textContent.trim();
    }

    stickyButton.textContent = selectedSize ? stickyButton.dataset.burvontiReadyText : 'Select Ring Size';
    stickyButton.toggleAttribute('data-burvonti-awaiting-size', !selectedSize);
  }

  function initializeEngraving(engraving) {
    if (engraving.hasAttribute('data-burvonti-engraving-initialized')) return;

    const toggle = engraving.querySelector('[data-burvonti-engraving-toggle]');
    const panel = engraving.querySelector('[data-burvonti-engraving-panel]');
    const input = engraving.querySelector('[data-burvonti-engraving-input]');
    const count = engraving.querySelector('[data-burvonti-engraving-count]');
    if (!toggle || !panel || !input) return;

    engraving.setAttribute('data-burvonti-engraving-initialized', '');

    const updateCount = () => {
      if (count) count.textContent = String(input.value.length);
    };

    toggle.addEventListener('change', () => {
      panel.hidden = !toggle.checked;
      input.disabled = !toggle.checked;
      toggle.setAttribute('aria-expanded', String(toggle.checked));
      if (toggle.checked) window.setTimeout(() => input.focus(), 0);
      updateCount();
    });
    input.addEventListener('input', updateCount);
    updateCount();
  }

  function initializeServiceTools(serviceTools) {
    if (serviceTools.hasAttribute('data-burvonti-service-tools-initialized')) return;

    const openButton = serviceTools.querySelector('[data-burvonti-hint-open]');
    const dialog = serviceTools.querySelector('[data-burvonti-hint-dialog]');
    const copyButton = serviceTools.querySelector('[data-burvonti-copy-link]');
    const consultationOpenButton = serviceTools.querySelector('[data-burvonti-consultation-open]');
    const consultationDialog = serviceTools.querySelector('[data-burvonti-consultation-dialog]');
    const consultationCloseButton = serviceTools.querySelector('[data-burvonti-consultation-close]');
    if (!openButton || !dialog) return;

    serviceTools.setAttribute('data-burvonti-service-tools-initialized', '');
    openButton.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    consultationOpenButton?.addEventListener('click', () => {
      if (typeof consultationDialog?.showModal === 'function') consultationDialog.showModal();
      else consultationDialog?.setAttribute('open', '');
    });
    consultationCloseButton?.addEventListener('click', () => consultationDialog?.close());
    consultationDialog?.addEventListener('click', (event) => {
      if (event.target === consultationDialog) consultationDialog.close();
    });
    if (consultationDialog?.querySelector('[data-burvonti-consultation-posted]')) {
      if (typeof consultationDialog.showModal === 'function') consultationDialog.showModal();
      else consultationDialog.setAttribute('open', '');
    }

    copyButton?.addEventListener('click', async () => {
      const url = copyButton.dataset.productUrl || window.location.href;
      const copied = await copyText(url);
      if (!copied) return;

      const defaultLabel = copyButton.dataset.defaultLabel || 'Copy Product Link';
      copyButton.textContent = copyButton.dataset.successLabel || 'Link Copied';
      window.setTimeout(() => {
        copyButton.textContent = defaultLabel;
      }, 1800);
    });
  }

  function initializeAdaptivePurchaseCta(section) {
    if (section.hasAttribute('data-burvonti-adaptive-purchase-initialized')) return;

    const inlinePurchaseRow = section.querySelector('.quantity-submit-row');
    const stickyPurchase = section.querySelector('.sticky-atc');
    if (!inlinePurchaseRow || !stickyPurchase) return;

    section.setAttribute('data-burvonti-adaptive-purchase-initialized', '');

    const updateAdaptiveState = (isInlineVisible, inlineTop) => {
      const inlinePurchaseIsBelowViewport = !isInlineVisible && inlineTop >= window.innerHeight;
      stickyPurchase.toggleAttribute('data-burvonti-adaptive-active', inlinePurchaseIsBelowViewport);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        updateAdaptiveState(entry.isIntersecting, entry.boundingClientRect.top);
      }, { threshold: 0.01 });
      observer.observe(inlinePurchaseRow);
      return;
    }

    const updateFromViewport = () => {
      const bounds = inlinePurchaseRow.getBoundingClientRect();
      updateAdaptiveState(bounds.bottom > 0 && bounds.top < window.innerHeight, bounds.top);
    };
    updateFromViewport();
    window.addEventListener('scroll', updateFromViewport, { passive: true });
    window.addEventListener('resize', updateFromViewport);
  }

  async function copyText(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand('copy');
      textarea.remove();
      return copied;
    } catch (error) {
      return false;
    }
  }

  function showRingSizeErrors(section, mainForm, message) {
    showError(mainForm?.querySelector('.js-form-error'), message);
    showError(section.querySelector('.sticky-atc__error'), message);
  }

  function hideRingSizeErrors(section, mainForm) {
    hideError(mainForm?.querySelector('.js-form-error'));
    hideError(section.querySelector('.sticky-atc__error'));
  }

  function revealRingSize(ringSize) {
    if (window.theme?.scrollToRevealElement) {
      window.theme.scrollToRevealElement(ringSize);
    } else {
      ringSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    window.setTimeout(() => {
      ringSize.querySelector('[data-ring-size-value]')?.focus();
    }, 250);
  }

  function reorderBurvontiNativeMediaGalleries() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (!gallery.closest(burvontiTemplateSelector)) return;
      const sourceItems = Array.from(gallery.querySelectorAll('.product-media-collage__item'));
      if (sourceItems.length < 3) return;

      const orderedMediaIds = getBurvontiNativeMediaOrder(sourceItems);
      if (orderedMediaIds.length < 3) return;

      [
        '.product-media-collage',
        'carousel-slider.mobile-only .slider__grid',
        'carousel-slider.thumbnails .slider__grid'
      ].forEach((selector) => {
        reorderBurvontiNativeMediaContainer(gallery, selector, orderedMediaIds);
      });
    });
  }

  function getBurvontiNativeMediaOrder(items) {
    const mainWhiteItem = getBurvontiNativeMainWhiteMediaItem(items);
    const videoItem = items.find((item) => item.querySelector('.product-media--video'));
    if (!mainWhiteItem || !videoItem) {
      return items.map((item) => item.getAttribute('data-media-id')).filter(Boolean);
    }

    const wearingItem = getBurvontiNativeWearingMediaItem(items, [mainWhiteItem, videoItem]);
    const promotedItems = [mainWhiteItem, videoItem, wearingItem].filter(Boolean);
    const promotedIds = new Set(promotedItems.map((item) => item.getAttribute('data-media-id')));
    const remainingItems = items.filter((item) => !promotedIds.has(item.getAttribute('data-media-id')));
    const guideItems = remainingItems.filter((item) => item.matches('[data-bvt-carat-guide]'));
    const otherRemainingItems = remainingItems.filter((item) => !item.matches('[data-bvt-carat-guide]'));

    return [...promotedItems, ...otherRemainingItems.slice(0, 2), ...guideItems, ...otherRemainingItems.slice(2)]
      .map((item) => item.getAttribute('data-media-id'))
      .filter(Boolean);
  }

  function getBurvontiNativeMainWhiteMediaItem(items) {
    return items.find((item) => (
      item.querySelector('.product-media--image') &&
      getBurvontiNativeMediaAltText(item).includes('main white')
    )) || items.find((item) => item.querySelector('.product-media--image')) || items[0];
  }

  function getBurvontiNativeWearingMediaItem(items, promotedItems) {
    const promotedIds = new Set(promotedItems.map((item) => item.getAttribute('data-media-id')));
    const imageItems = items.filter((item) => (
      item.querySelector('.product-media--image') &&
      !promotedIds.has(item.getAttribute('data-media-id'))
    ));

    return imageItems.find((item) => getBurvontiNativeMediaAltText(item).includes('wearing')) || imageItems[0];
  }

  function getBurvontiNativeMediaAltText(item) {
    return (item.querySelector('img')?.getAttribute('alt') || '').toLowerCase();
  }

  function reorderBurvontiNativeMediaContainer(gallery, selector, orderedMediaIds) {
    const container = gallery.querySelector(selector);
    if (!container) return;

    const children = Array.from(container.children).filter((child) => child.getAttribute('data-media-id'));
    if (children.length < 3) return;

    const childrenByMediaId = new Map(children.map((child) => [child.getAttribute('data-media-id'), child]));
    const appended = new Set();
    const orderedChildren = orderedMediaIds
      .map((mediaId) => childrenByMediaId.get(mediaId))
      .filter(Boolean);

    [...orderedChildren, ...children].forEach((child) => {
      const mediaId = child.getAttribute('data-media-id');
      if (appended.has(mediaId)) return;
      appended.add(mediaId);
      child.setAttribute('data-burvonti-native-media-order', String(appended.size));
      container.appendChild(child);
    });
  }

  function addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return result;
  }

  function showError(errorNode, message) {
    if (!errorNode) return;
    errorNode.textContent = message;
    errorNode.hidden = false;
  }

  function hideError(errorNode) {
    if (!errorNode) return;
    errorNode.textContent = '';
    errorNode.hidden = true;
  }
})();
